/** Centrifuge: 0 — штатный disconnect, 2 — transport closed (reconnect). */
const TRANSIENT_CODES = new Set([0, 2])

const TRANSIENT_MESSAGES = [
  'transport closed',
  'connection closed',
  'websocket',
  'network error',
  'failed to fetch',
  'load failed',
  'the operation was aborted',
  'aborterror',
]

const getMessage = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message
  }

  if (typeof error === 'string') {
    return error
  }

  if (typeof error === 'object' && error !== null && 'message' in error) {
    const { message } = error as { message?: unknown }

    return typeof message === 'string' ? message : ''
  }

  return ''
}

export const getErrorMessage = (error: unknown, fallback: string): string => {
  const message = getMessage(error)

  return message || fallback
}

export const shouldCaptureSentryException = (error: unknown): boolean => {
  if (!error) {
    return false
  }

  if (typeof error === 'object' && error !== null && 'code' in error) {
    const code = Number((error as { code?: number }).code)

    if (!Number.isNaN(code) && TRANSIENT_CODES.has(code)) {
      return false
    }
  }

  const normalized = getMessage(error).toLowerCase()

  if (TRANSIENT_MESSAGES.some((pattern) => normalized.includes(pattern))) {
    return false
  }

  return true
}
